<script lang="ts" setup>
  import { PHONE, PHONE_LINK } from './HotlineButtonQC.constants'
  import ButtonQC from '@qicgroupdoha/qic-connect-ds/components/ButtonQC'

  interface Props {
    phone?: string
    link?: string
  }

  withDefaults(defineProps<Props>(), {
    phone: PHONE,
    link: PHONE_LINK,
  })
</script>

<template>
  <ButtonQC :href="link" wide variant="outline" size="medium" data-test="hotline-button">
    <div class="hotline-button__content">
      {{ $t('common.call.button') }} <span class="ltr">{{ phone }}</span>
    </div>
  </ButtonQC>
</template>

<style lang="scss" scoped>
  .hotline-button__content {
    display: flex;
    align-items: center;
    gap: var(--spacing-2);
  }
</style>
